import { render, staticRenderFns } from "./LawExpertOpinionOutcomeList.vue?vue&type=template&id=8bfae626&"
import script from "./LawExpertOpinionOutcomeList.vue?vue&type=script&lang=js&"
export * from "./LawExpertOpinionOutcomeList.vue?vue&type=script&lang=js&"
import style0 from "./LawExpertOpinionOutcomeList.vue?vue&type=style&index=0&id=8bfae626&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports